import c from "@square/web-rpc-client";
import { RpcLoggerFactory as f, ConsoleRequestLogger as u } from "@square/web-rpc-client/utils";
import { SaasSharedUiQueryContext as s } from "../init.js";
import { getDefaultRequestHeaders as m } from "./headers.js";
class R extends u {
  logRequest(...e) {
    s.config.loggingEnabled && super.logRequest(...e);
  }
  logResponse(...e) {
    s.config.loggingEnabled && super.logResponse(...e);
  }
  logError(...e) {
    s.config.loggingEnabled && super.logError(...e);
  }
}
function q(t) {
  const { additionalHeaders: e, urlForMethod: n, ...d } = t || {}, i = () => {
    const o = m();
    return e && (e instanceof Map ? e : e()).forEach((a, r) => {
      o.set(r, a);
    }), o;
  }, p = (o, g, a) => {
    const r = n ? n(o, g, a) : o, { baseUrl: l } = s.config;
    return l ? `${l}${r}` : r;
  };
  return c({
    loggerFactory: new f(R),
    additionalHeaders: i,
    urlForMethod: p,
    ...d
  });
}
export {
  R as SaasSharedUiRequestLogger,
  q as default
};
